import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UtilitiesPaginatedNotificationUserResponse } from '@libs/generated-types/utilities';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../@core/services/environment.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private readonly apiUrl: string = '';

  constructor(
    private readonly http: HttpClient,
    private readonly environmentService: EnvironmentService,
  ) {
    // Use environment service to get the API URL
    this.apiUrl = this.environmentService.utilitiesServiceUrl + '/app/notifications';
  }

  getUserNotifications(query: any): Observable<UtilitiesPaginatedNotificationUserResponse> {
    return this.http.get<UtilitiesPaginatedNotificationUserResponse>(this.apiUrl, { params: query });
  }

  markAsRead(notificationId: string): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/${notificationId}/reads`, {});
  }

  bulkMarkAsRead(notificationIds: string[]): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/reads`, { notificationIds });
  }

}
